var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_73293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_73293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 23H10.4L19.025 14.375L17.625 12.975L9 21.6V23ZM23.3 12.925L19.05 8.725L20.45 7.325C20.8333 6.94167 21.3043 6.75 21.863 6.75C22.421 6.75 22.8917 6.94167 23.275 7.325L24.675 8.725C25.0583 9.10833 25.2583 9.571 25.275 10.113C25.2917 10.6543 25.1083 11.1167 24.725 11.5L23.3 12.925ZM21.85 14.4L11.25 25H7V20.75L17.6 10.15L21.85 14.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledEdit);
export default __webpack_public_path__ + "static/media/DisabledEdit.c802d2df0a79149494c70bfbcc87305f.svg";
export { ForwardRef as ReactComponent };